<template>
  <div class="chat-container">
    <Chat
      v-if="visible"
      :participants="participants"
      :myself="myself"
      :messages="messages"
      :chat-title="chatTitle"
      :placeholder="placeholder"
      :colors="colors"
      :border-style="borderStyle"
      :hide-close-button="hideCloseButton"
      :close-button-icon-size="closeButtonIconSize"
      :submit-icon-size="submitIconSize"
      :load-more-messages="toLoad.length > 0 ? loadMoreMessages : null"
      :async-mode="asyncMode"
      :scroll-bottom="scrollBottom"
      :display-header="false"
      :send-images="false"
      :profile-picture-config="profilePictureConfig"
      @onMessageSubmit="onMessageSubmit"
      @onType="onType"
    />
  </div>
</template>

<script>
import { Chat } from "vue-quick-chat";
import "vue-quick-chat/dist/vue-quick-chat.css";

export default {
  props: ["cityId", "isDirect"],
  components: {
    Chat
  },
  data() {
    return {
      myId: null,
      visible: false,
      city: null,
      type: null,
      participants: [],
      myself: {
        name: "",
        id: null,
        profilePicture: ""
      },
      messages: [],
      chatTitle: "",
      placeholder: "Write new message...",
      colors: {
        header: {
          bg: "#343b41",
          text: "#fff"
        },
        message: {
          myself: {
            bg: "#fff",
            text: "#000"
          },
          others: {
            bg: "#20a8d8",
            text: "#fff"
          },
          messagesDisplay: {
            bg: "#3a4149"
          }
        },
        submitIcon: "#8c8c8c",
        submitImageIcon: "white"
      },
      borderStyle: {
        topLeft: "0px",
        topRight: "0px",
        bottomLeft: "0px",
        bottomRight: "0px"
      },
      hideCloseButton: true,
      submitIconSize: 35,
      closeButtonIconSize: "20px",
      asyncMode: false,
      toLoad: [],
      scrollBottom: {
        messageSent: true,
        messageReceived: false
      },
      displayHeader: true,
      profilePictureConfig: {
        others: true,
        myself: true,
        styles: {
          width: "45px",
          height: "45px",
          borderRadius: "50%"
        }
      }
    };
  },
  methods: {
    getMessages() {
      let params = {};
      params = {
        client: this.city
      };
      this.$http
        .get("api/" + this.type + "/getMessages.php", {
          params
        })
        .then(
          res => {
            var me = false;
            var myArray = {};
            var myArray1 = {};
            var date = null;

            var getMessages = res.data.records;

            if (
              getMessages &&
              res.data.message != "No products found." &&
              getMessages.length > 0
            ) {
              getMessages.forEach(obj => {
                date = new Date(obj.time);

                if (obj.sender == this.myself.id) {
                  me = true;
                } else {
                  me = false;
                  var img = "";
                  if (obj.sender < 4) {
                    img =
                      process.env.VUE_APP_TRACKER_URL +
                      "tracker_private/images/users/" +
                      obj.senderImage;
                  } else {
                    img =
                      process.env.VUE_APP_TRACKER_URL +
                      "tracker_private/images/people/" +
                      obj.senderImage;
                  }

                  myArray1 = {
                    name: obj.senderName,
                    id: obj.sender,
                    profilePicture: img
                  };

                  const found = this.participants.some(
                    el => el.id === obj.sender
                  );
                  if (!found) this.participants.unshift(myArray1);
                }

                myArray = {
                  content: obj.content,
                  myself: me,
                  participantId: obj.sender,
                  timestamp: {
                    year: date.getFullYear(),
                    month: date.getMonth(),
                    day: date.getDay(),
                    hour: date.getHours(),
                    minute: date.getMinutes(),
                    millisecond: 123
                  },
                  type: "text"
                };

                this.messages.unshift(myArray);
                myArray = {};
                myArray1 = {};
              });
            }
            this.visible = true;
          },
          err => {
            console.log(err);
            this.visible = true;
          }
        );
    },
    onType: function() {
      //here you can set any behavior
    },
    loadMoreMessages(resolve) {
      setTimeout(() => {
        resolve(this.toLoad); //We end the loading state and add the messages
        //Make sure the loaded messages are also added to our local messages copy or they will be lost
        this.messages.unshift(...this.toLoad);
        this.toLoad = [];
      }, 1000);
    },
    onMessageSubmit: function(message) {
      this.messages.push(message);

      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;

      let params = {};
      params = {
        client_num: this.city,
        timestamp: dateTime,
        sender_id: this.myself.id,
        receiver_id: 9999,
        content: message.content
      };
      this.$http
        .get("api/" + this.type + "/sendMessage.php", {
          params
        })
        .then(
          () => {},
          err => {
            console.log(err);
          }
        );
    }
  },
  mounted() {
    this.myself.id = localStorage.getItem("user");
    this.myself.name = localStorage.getItem("full_name");
    this.myself.profilePicture = localStorage.getItem("user_picture");
    this.city = this.cityId;
    if (this.isDirect == 0) {
      this.type = "chat";
    } else {
      this.type = "inbox";
    }
    this.getMessages();
  }
};
</script>

<style>
.quick-chat-container .container-message-manager {
  box-shadow: none !important;
}
.chat-container {
  height: 403px;
}
.quick-chat-container .container-message-manager {
  background: #343b41 !important;
}
.quick-chat-container .container-message-manager .message-input {
  color: white;
}
.container-message-display::-webkit-scrollbar {
  display: none;
}
</style>
